// 한국어 조사 고르기 — 임베드·협업 도구 화면의 고정 이름(EmbedHost EMBED_APPS title · constants/collabTools label) 뒤에 붙인다.
// 🔴 사용자가 넣은 이름(파일명 등)은 한글이 아닐 수 있어 «을(를)» 그대로 두는 자리가 있다(DrivePicker).

// 마지막 글자 받침으로 «을/를» 을 고른다. 한글 음절이 아니면 «을(를)».
export function withEulReul(word) {
  const s = String(word ?? '');
  if (!s) return s;
  const c = s.charCodeAt(s.length - 1);
  if (c >= 0xac00 && c <= 0xd7a3) return s + ((c - 0xac00) % 28 === 0 ? '를' : '을');
  return s + '을(를)';
}
